// Single source of truth for the marketing-surface palette (the `.mk` design
// system). marketing-ui.tsx interpolates these into MARKETING_CSS, and the
// auth pages (login/signup) + PricingSection import them directly so the
// public surfaces can't drift apart again (each previously kept its own
// hand-typed copy of these values).
//
// Plain module with zero imports — safe to use from both server and client
// components. The authenticated app does NOT use these; it has its own token
// system in globals.css.

export const MK = {
  bg:          '#FAF9F6',
  surface:     '#FFFFFF',
  ink:         '#14140F',
  body:        '#56554E',
  faint:       '#6E6D63', // ≥4.5:1 on cream — small text uses this
  line:        '#E7E5DC',
  lineSoft:    '#F0EEE6',
  green:       '#2E5545',
  greenDeep:   '#24433A',
  greenInk:    '#1B332A',
  greenSoft:   '#EDF4F0',
  greenBorder: '#CBDED5',
  greenText:   '#4A7A68',
  greenPale:   '#9FC3B2',
  error:       '#C0392B',
} as const
